import axios from 'axios';
import { axiosInstance } from '../interceptor';

const API_URL =`${process.env.REACT_APP_API_URL}custom`
//  `${process.env.REACT_APP_API_URL}custom`

export const fetchWallets = async (pageNo = 1, limit = 10) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/userWalletDetails`, {
      params: { pageNo, limit },
      headers: {
        'Content-Type': 'application/json',
      },
    });
   
    return response.data;
  } catch (error) {
    console.error('Error fetching wallets:', error);
    throw error;  // Re-throw the error so that calling function can handle it
  }
};




